
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { AJSCommonsHttpUtilServiceProvider } from './services/ib-utils/ib-check-in-http-utils.service';
import { LiteralFormatterPipe } from './pipes/literalFormatter.pipe';

const downgradedComponents = [
    
];
const components = [
    LiteralFormatterPipe,
    ...downgradedComponents
];
@NgModule({
    imports: [
        TranslateModule,
        FormsModule,
        CommonModule,
        TitleCasePipe
    ],
    exports: components,
    declarations: components,
    providers: [
        AJSCommonsHttpUtilServiceProvider
    ]
})
export class IbCheckinSharedModule {
    static components = downgradedComponents;
}
